import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable()
export class WorkValidationService {
  constructor(private http: HttpClient) {
  }

  createTimestamps(projectType) {
    return this.http.post<any>(`${environment.apiUrl}/hire/timestamp`, projectType);
  }

  addTimestamp(params) {
    return this.http.post<any>(`${environment.apiUrl}/hire/add-timestamp`, params);
  }

  unvalidateShifts(params) {
    return this.http.post<any>(`${environment.apiUrl}/hire/unvalidate`, params);
  }

  deleteExpense(param) {
    return this.http.delete<any>(`${environment.apiUrl}/hire/delete-expense/`, param);
  }

  storeShiftExpenses(params) {
    return this.http.post<any>(`${environment.apiUrl}/hire/store-expenses`, params);
  }

  validateTimestamp(params) {
    return this.http.post<any>(`${environment.apiUrl}/hire/validate-timestamp`, params);
  }

  getTimestampsHistory(allocationId) {
    return this.http.get<any>(`${environment.apiUrl}/hire/timestamps-history/${allocationId}`);
  }

  storeExpense(params) {
    return this.http.post<any>(`${environment.apiUrl}/hire/store-expense`, params);
  }

  storeSalary(params) {
    return this.http.post<any>(`${environment.apiUrl}/hire/store-salary`, params);
  }

  storeRenumeration(params) {
    return this.http.post<any>(`${environment.apiUrl}/hire/store-renumeration`, params);
  }

  addShiftSalary(params) {
    return this.http.post<any>(`${environment.apiUrl}/hire/add-shift-salary`, params);
  }

  addShiftExpense(params) {
    return this.http.post<any>(`${environment.apiUrl}/hire/add-shift-expense`, params);
  }

  addComment(id, params) {
    return this.http.put<any>(`${environment.apiUrl}/hire/allocation/add-comment/${id}`, params);
  }

  // JS-1573: per-timestamp comment threads
  addTimestampComment(payload: {
    employee_timestamp_id: number;
    type: 'employee' | 'client' | 'admin' | 'timestamp_manager';
    comment: string;
  }) {
    return this.http.post<any>(`${environment.apiUrl}/hire/timestamp-comment`, payload);
  }

  deleteTimestampComment(id: number) {
    return this.http.delete<any>(`${environment.apiUrl}/hire/timestamp-comment/${id}`);
  }

  uploadExpenseImage(file: File, expenseId: number, projectId: number) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', expenseId.toString());
    formData.append('project_id', projectId.toString());
    return this.http.post<any>(`${environment.apiUrl}/hire/upload-expense-image`, formData);
  }

  uploadExpenseImages(files: File[], expenseId: number, projectId: number) {
    const formData = new FormData();
    for (const file of files) {
      formData.append('files[]', file);
    }
    formData.append('id', expenseId.toString());
    formData.append('project_id', projectId.toString());
    return this.http.post<any>(`${environment.apiUrl}/hire/upload-expense-image`, formData);
  }

  deleteExpenseImage(expenseId: number, projectId: number) {
    return this.http.post<any>(`${environment.apiUrl}/hire/delete-expense-image`, {
      id: expenseId,
      project_id: projectId
    });
  }

  deleteExpenseImageById(imageId: number, projectId: number) {
    return this.http.post<any>(`${environment.apiUrl}/hire/delete-expense-image`, {
      image_id: imageId,
      project_id: projectId
    });
  }

  getRoleWagesWithCriteria(allocationId: number) {
    return this.http.get<any>(`${environment.apiUrl}/hire/expenses-and-wages/${allocationId}`);
  }

  resetToPlannedHours(allocationIds: number[]) {
    return this.http.post<any>(`${environment.apiUrl}/hire/bulk-reset-to-planned`, { allocations: allocationIds });
  }

  addBulkComment(allocationIds: number[], comment: string, type: string = 'client') {
    return this.http.post<any>(`${environment.apiUrl}/hire/bulk-add-comment`, { allocations: allocationIds, comment, type, append: true });
  }
}
